var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('model-details',{staticClass:"event-details",attrs:{"fetch-model":_vm.fetchEvent},on:{"model-loaded":_vm.handleEventLoaded}},[(_vm.event)?_c('room-details',{attrs:{"room":_vm.room,"skip-welcome":_vm.skipWelcome}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }